var map = {
	"./amex.png": "6e80",
	"./chip.png": "8e19",
	"./dinersclub.png": "80db",
	"./discover.png": "e8d1",
	"./elo.png": "5ee2",
	"./hiper.png": "2dae",
	"./jcb.png": "d85c",
	"./mastercard.png": "3c3e",
	"./troy.png": "ceb6",
	"./unionpay.png": "715b",
	"./visa.png": "a2368"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";